import { isMainTabsRoute } from '../../shell/navigation/navigationManifest';
import { navigateInShell } from '../../shell/navigation/rootNavigation';

export type BranchSalesHistoryCashierFilter = 'all' | string;

/** Alcance Informes serializable para drill-down a SalesList. */
export type SalesListReportsScopeParams = {
  categoryId?: string | null;
  itemType?: string | null;
  productId?: string | null;
  brandId?: string | null;
  supplierId?: string | null;
  customerId?: string | null;
};

export type SaleDetailRouteParams = {
  saleId: string;
};

export type SalesListRouteParams = {
  fromYmd?: string;
  toYmd?: string;
  cashierFilter?: BranchSalesHistoryCashierFilter;
  search?: string;
  /** Título del header (ej. período de informes). */
  screenTitle?: string;
  /** Web master–detail: venta seleccionada en panel derecho. */
  saleId?: string;
  /** Drill-down desde Informes: filtrar filas con pago no cobrado. */
  paymentPendingOnly?: boolean;
  /** Filtros de alcance Informes (producto, categoría, cliente, etc.). */
  reportsScope?: SalesListReportsScopeParams;
};

type NavigationLike = {
  navigate: (route: string, params?: SaleDetailRouteParams | SalesListRouteParams) => void;
};

export const SALE_DETAIL_ROUTE = 'SaleDetail';
export const SALES_LIST_ROUTE = 'SalesList';

export function openSaleDetail(
  navigation: NavigationLike,
  params: SaleDetailRouteParams
): void {
  navigateInShell(navigation, SALE_DETAIL_ROUTE, params);
}

export function openSalesList(
  navigation: NavigationLike,
  params?: SalesListRouteParams
): void {
  if (isMainTabsRoute(SALES_LIST_ROUTE)) {
    navigation.navigate(SALES_LIST_ROUTE, params ?? {});
    return;
  }
  navigateInShell(navigation, SALES_LIST_ROUTE, params ?? {});
}
